import _ from 'lodash';
import React from 'react';
import {
  DateField,
  TextField,
  Labeled,
  BooleanInput,
  ReferenceManyField,
  SingleFieldList,
  TextInput,
  SelectInput,
  ReferenceArrayInput,
  FormDataConsumer,
  SelectArrayInput,
} from 'react-admin';
import { adminLevelLabels } from '../../../helpers/mappings';
import '../styles.css';
import { phoneFormatter, phoneParser, validateRepresentatives } from '../../../helpers/utils';

export default (props) => {
  const { record } = props;
  return (
    <table style={{ width: '100%' }}>
      <tbody>
        <tr>
          <td style={{ width: '50%' }}>
            <Labeled label="Account" record={record}>
              <ReferenceManyField
                label="Accounts"
                basePath="/accounts"
                reference="accounts"
                target="userId"
                source="id"
                record={record}
              >
                <SingleFieldList linkType={false}>
                  <TextField source="accountNumber" />
                </SingleFieldList>
              </ReferenceManyField>
            </Labeled>
          </td>
          <td style={{ width: '50%' }}>
            <Labeled label="User Status">
              {
                record.status ?
                  <span className="normalField">{record.status.charAt(0).toUpperCase() + record.status.slice(1)}</span> :
                  <span className="normalField">N/A</span>
              }
            </Labeled>
          </td>
        </tr>
        <tr>
          <td>
            <Labeled label="Full Name">
              <span
                className="normalField"
              >{`${record.firstName}${_.isEmpty(record.middleName) ? ' ' : ` ${record.middleName} `}${record.lastName}`}
              </span>
            </Labeled>
          </td>
          <td>
            <TextInput style={{ width: '50%' }} source="email" type="email" label="E-mail" />
          </td>
          <td />
        </tr>
        <tr>
          <td>
            <TextInput style={{ width: '50%' }} source="contact.dayTelephone" label="Daytime Telephone" parse={phoneParser} format={phoneFormatter} />
          </td>
          <td>
            <TextInput style={{ width: '50%' }} source="contact.eveningTelephone" label="Evening Telephone" parse={phoneParser} format={phoneFormatter} />
          </td>
          <td />
        </tr>
        <tr>
          <td>
            <SelectInput style={{ width: '50%' }} label="Role" source="role" choices={adminLevelLabels} optionText="name" optionValue="id" />
          </td>
          <td>
            <Labeled label="Approved At">
              {record.approvedAt ? <DateField source="approvedAt" record={record} /> :
              <span className="normalField">Not Approved</span>}
            </Labeled>
          </td>
        </tr>
        <tr>
          <td>
            <Labeled label="Created At">
              <DateField className="normalField" source="createdAt" record={record} />
            </Labeled>
          </td>
          <td>
            <Labeled label="Updated At">
              <DateField className="normalField" source="updatedAt" record={record} />
            </Labeled>
          </td>
        </tr>
        <tr>
          <td>
            <Labeled label="Sign Up Completed At">
              {record.signUpCompletedAt ? <DateField source="signUpCompletedAt" record={record} /> :
              <span className="normalField">Not Completed</span>}
            </Labeled>
          </td>
          <td>
            <BooleanInput source="solicited" label="Is Solicited" record={record} />
          </td>
        </tr>
        <FormDataConsumer record={record}>
          {({ formData }) => formData && formData.solicited && (
          <tr>
            <td />
            <td>
              <ReferenceArrayInput
                record={record}
                source="representatives"
                reference="userRepresentatives"
                label="Representatives Soliciting Advice"
                basePath="users"
                filter={{ role: '_not_null_' }}
                validate={validateRepresentatives}
                style={{ width: '100%' }}
              >
                <SelectArrayInput optionText={choice => `${choice.firstName} (${choice.lastName})`} />
              </ReferenceArrayInput>
            </td>
          </tr>)}
        </FormDataConsumer>
      </tbody>
    </table>
  );
};




// WEBPACK FOOTER //
// ./src/components/User/children/BasicInformation.jsx